<button type="button"
        class='flex flex-middle'>
    <multisite-flag class="inline-flex"
                    [ngClass]="isFooter ? 'm-r-1' : 'm-r-5'"
                    [siteId]="site.siteId"></multisite-flag>
    <span class="underline inline-block"
          *ifSize="'XL'">&nbsp;{{site.currency | lowercase}}</span>
    <span [ngClass]="isFooter ? 'h4 col-11' : 'p1'"
          [tradeClass]="'col-12'"
          *ifSize="'SM'">{{site.currency | uppercase}}</span>
</button>